import Compaign from 'assets/svgs/Compaign';
import Dashboard from 'assets/svgs/Dashboard';
import { Link } from 'react-router-dom';
import General from './General';


const SellerSidebar = () => {
    return (
        <div>
            <div className='w-[250px]'>
                <div className='light-shadow py-4 px-2 flex flex-col gap-4 rounded-lg'>
                    <Link to='/seller/dashboard' className='flex items-center gap-3 cursor-pointer hover:text-primary'>
                        <div className='round-icon'>
                            <Dashboard />
                        </div>
                        <p>Dashboard</p>
                    </Link>
                    <Link to='/seller/orders' className='flex items-center gap-3 cursor-pointer hover:text-primary'>
                        <div className="round-icon">
                            <Compaign />
                        </div>
                        <p>Orders</p>
                    </Link>
                    <Link to='/seller/products' className='flex items-center gap-3 cursor-pointer hover:text-primary'>
                        <div className="round-icon text-white">
                            <i className="uil uil-sitemap text-lg"></i>
                        </div>
                        <p>Products</p>
                    </Link>
                    <Link to='/seller/earnings' className='flex items-center gap-3 cursor-pointer hover:text-primary'>
                        <div className="round-icon text-white">
                            <i className="uil uil-usd-circle text-lg"></i>
                        </div>
                        <p>Earnings</p>
                    </Link>
                </div>
                <General />
            </div>
        </div>
    )
}

export default SellerSidebar;